module.exports = __webpack_public_path__ + "static/media/img_8.55afb317.png";